// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { Button, Row, Link, Container, Header, Main, Footer, Carousel, CarouselItem, Divider, Menu, MenuItem, Col, Card, Tabs, TabPane, Steps, Step} from 'element-ui';
import { Form, FormItem, Input, Select, Option, TimePicker, Switch, Checkbox, CheckboxGroup, DatePicker, RadioGroup, Radio, PageHeader, Dialog, Notification  } from 'element-ui';
import { Message, MessageBox, Tag, Loading, Rate, Table, TableColumn, Result, Collapse, CollapseItem, Popover, Avatar } from 'element-ui';
import App from './App.vue';

import axios from '../node_modules/axios';

// 引入路由配置
import router from './router';

// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';


// 关闭生产模式下给出的提示
// Vue.config.productionTip = false

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.prototype.$axios = axios;
// axios.defaults.baseURL = '/api';

Vue.use(Button);
Vue.use(Row);
Vue.use(Link);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Divider);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Col);
Vue.use(Card);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(TimePicker);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(PageHeader);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Loading.directive);
Vue.use(Rate);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Result);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popover);
Vue.use(Avatar);
// Vue.use(Notification);
// Vue.use(Message);
// Vue.use(MessageBox);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;


Vue.component(CollapseTransition.name, CollapseTransition);

new Vue({
  el: '#app',
  router,
  axios,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js